export default __webpack_public_path__ + "static/media/our_partner_2.69ef8803.png";